export interface Category {
  id: string;
  title: string;
  icon: string;
}

export const categories: Category[] = [
  { id: '1', title: 'วิทยาศาสตร์', icon: 'flask' },
  { id: '2', title: 'วัฒนธรรม', icon: 'diamond' },
  { id: '3', title: 'ประวัติศาสตร์', icon: 'hourglass' },
  { id: '4', title: 'สัตว์โลก', icon: 'paw' },
  { id: '5', title: 'ภูมิศาสตร์', icon: 'earth' },
  { id: '6', title: 'เทคโนโลยี', icon: 'flash' },
  { id: '7', title: 'อาหาร', icon: 'beer' },
  { id: '8', title: 'ศิลปะและดนตรี', icon: 'musical-note' },
  { id: '9', title: 'การแพทย์และสุขภาพ', icon: 'medical' },
  { id: '10', title: 'ธรรมชาติและสิ่งแวดล้อม', icon: 'leaf' },
  { id: '11', title: 'กีฬา', icon: 'football' },
  { id: '12', title: 'ดาราศาสตร์', icon: 'planet' },
  { id: '13', title: 'ภาษาและวรรณกรรม', icon: 'language' },
  { id: '14', title: 'สถาปัตยกรรม', icon: 'business' },
  { id: '15', title: 'เกร็ดความรู้ท้องถิ่น', icon: 'pin' },
  { id: '16', title: 'นวัตกรรมและการประดิษฐ์', icon: 'bulb' },
];